// extracted by mini-css-extract-plugin
module.exports = {"section":"EmailPage_section__3oPTo","container":"EmailPage_container__1-vbh","input":"EmailPage_input__ZKSqo","label":"EmailPage_label__1rING","button":"EmailPage_button__1YMu9"};